import { Dimension, Answers } from '../types';

export const calculateScores = (dimensions: Dimension[], answers: Answers) => {
  const scores: { [dimensionId: string]: number } = {};
  let overallTotal = 0;
  let overallCount = 0;

  dimensions.forEach(dim => {
    let dimTotal = 0;
    dim.questions.forEach(q => {
      const score = answers[q.id] || 0;
      dimTotal += score;
      overallTotal += score;
      overallCount++;
    });
    // Average score for dimension (1-5 scale)
    scores[dim.id] = dim.questions.length > 0 ? (dimTotal / dim.questions.length): 0;
  });

  const overallScore = overallCount > 0 ? (overallTotal / overallCount) : 0;

  return {
    dimensionScores: scores,
    overallScore
  };
};

export const getMaturityLevel = (score: number): string => {
  if (score <= 1.5) return "Novice";
  if (score <= 2.5) return "Explorer";
  if (score <= 3.5) return "Practitioner";
  if (score <= 4.5) return "Expert";
  return "Leader";
};
